import { Box } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React, { useCallback } from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import Button from 'atoms/Button/Button';

const isDateInCurrentMonth = (date: Date) => {
  const now = new Date();
  return now.getMonth() === date.getMonth() && now.getFullYear() === date.getFullYear();
};

type DatePickerFooterProps = {
  changeMonth: ReactDatePickerCustomHeaderProps['changeMonth'];
  changeYear: ReactDatePickerCustomHeaderProps['changeYear'];
  monthDate: ReactDatePickerCustomHeaderProps['monthDate'];
  focusTodayButton: () => void;
};

const DatePickerFooter = (props: DatePickerFooterProps): React.ReactElement | null => {
  const { changeMonth, changeYear, monthDate, focusTodayButton } = props;
  const DatePickerTheme = useMultiStyleConfig('DatePickerTheme', props);

  const handleClick = useCallback(() => {
    const todayDate = new Date();
    changeMonth(todayDate.getMonth());
    changeYear(todayDate.getFullYear());
    focusTodayButton();
  }, [changeMonth, changeYear, focusTodayButton]);

  if (isDateInCurrentMonth(monthDate)) {
    return null;
  }

  return (
    <Box sx={DatePickerTheme.footerContainer}>
      <Button className="today-button" onClick={handleClick} size="sm" variant="ghost">
        Today
      </Button>
    </Box>
  );
};

export default DatePickerFooter;
